import {
  ProductListAddRequestDto,
  ProductListBaseAddRequestDto,
} from '@epicuro-next/data/engagement/engagement-models';
import { isNonNullish } from '@epicuro-next/utilities';
import { throwError } from 'rxjs';

import {
  mapLegacyListTypeToEngagement,
  mapLegacyMediaRequestToEngagement,
} from '../../mappers-to-engagement';

export function engagementCreateListBodyMapper(
  body: Omit<ProductListBaseAddRequestDto, 'accountId'>,
  mediaRequired = false,
): ProductListAddRequestDto {
  const legacyMedia = body.media ? body.media[0] : undefined;
  if (!legacyMedia && mediaRequired) {
    throw throwError(() => new Error('Media is not declared'));
  }
  const media = legacyMedia
    ? mapLegacyMediaRequestToEngagement(legacyMedia)
    : undefined;

  const payload: ProductListAddRequestDto = {
    name: body.name,
    description: body?.description,
    media,
    originalProductListId: body.originalProductListId ?? undefined,
    productReferences:
      body.productReferences?.filter(isNonNullish) ?? undefined,
    type: mapLegacyListTypeToEngagement(body?.type),
    stylesOnly: body.stylesOnly,
    layout: body.layout
      ? typeof body.layout === 'string'
        ? body.layout
        : JSON.stringify(body.layout)
      : undefined,
  } as unknown as ProductListAddRequestDto;

  if (body?.orderType) payload.orderType = body.orderType.toLowerCase();

  return payload;
}
